import type { ReactNode } from 'react';

export const symbol_speed_0_5: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M435-277q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h140v-115H435q-12.75 0-21.37-8.63Q405-469.25 405-482v-171q0-12.75 8.63-21.38Q422.25-683 435-683h170q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H465v111h110q24 0 42 18t18 42v115q0 24-18 42t-42 18H435Zm-141.5-8.68q-8.5-8.67-8.5-21.5 0-12.82 8.68-21.32 8.67-8.5 21.5-8.5 12.82 0 21.32 8.68 8.5 8.67 8.5 21.5 0 12.82-8.68 21.32-8.67 8.5-21.5 8.5-12.82 0-21.32-8.68Z"
		/>
	</svg>
);
